import { Controller } from '@hotwired/stimulus';

/**
 * 자식 체크박스를 체크하면 부모 체크박스가 체크됩니다.
 * 부모 체크박스를 해제하면 자식들의 체크박스들이 해제됩니다.
 */
export default class extends Controller {
  static targets = ['parentCheckbox', 'childCheckbox'];

  childCheckboxTargetConnected(element) {
    element.addEventListener('click', () => {
      if (!this.parentCheckboxTarget.checked) {
        this.parentCheckboxTarget.checked = true;
      }
    });
  }

  parentCheckboxTargetConnected(element) {
    element.addEventListener('click', () => {
      this.childCheckboxTargets.forEach((child) => {
        child.checked = false;
      });
    });
  }
}
